module.exports = __webpack_public_path__ + "static/img/产品智能化流程_详情_02.a1d4345.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/data/img/about_article/初创企业成长计划_详情/产品智能化流程_详情_02.png
// module id = 638
// module chunks = 1